import React, { useState } from 'react'
import { ButtonV2, SidePanelInfo } from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons'

import { QAndASidePannel } from '../../../components/FlyOutUsageMetering/RightSectionComponents/QAndASidePannel'
import { useStyles } from './MarketplaceMultipleApn.styles'
import type { HelpFaqsSectionProps } from './MarketplaceMultipleApn.types'

export const HelpFaqsSection: React.FC<HelpFaqsSectionProps> = ({
  title,
  content,
}) => {
  const { classes } = useStyles()
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const openDrawer = () => {
    setIsOpen(true)
  }
  const toggleDrawer = async () => {
    setIsOpen(false)
  }

  return (
    <>
      <div>
        <ButtonV2
          key={'cloud-settings-help-drawer'}
          styleType="link"
          data-testid="cloud-settings-help-button-drawer"
          icon={
            <FontAwesomeIcon icon={faCircleInfo} className={classes.infoIcon} />
          }
          onClick={openDrawer}
        >
          Help & FAQs
        </ButtonV2>
      </div>
      <SidePanelInfo
        icon={
          <FontAwesomeIcon
            icon={faCircleInfo}
            className={classes.sidePanelInfoIcon}
          />
        }
        headerTitle={
          <div className={classes.sidePanelTitleText}>Help and FAQs</div>
        }
        title={title}
        open={isOpen}
        onClose={toggleDrawer}
        content={
          <div className={classes.qAndAParentWrapper}>
            <QAndASidePannel content={content} />
          </div>
        }
      />
    </>
  )
}
